import React from 'react';
import styles from './NotFound.module.css'
import {Icon} from 'semantic-ui-react'


const NotFound = () => {
    return (
        <div  style={{textAlign:"center", marginTop: '150px'}}>
            <div className={styles.notFoundContent}>
                <Icon inverted color='red' name='exclamation triangle' size='massive'  />
                <p></p>
                <p>İşleminizi gerçekleştiremiyoruz</p>
                <p>Sayfa bilgisi hatalı girilmiş ya da oturum süreniz sonlanmış olabilir</p>
            </div>
        </div>
    );
};
export default NotFound;
